// KPI Card component - displays a metric in a card
// Used on Executive Dashboard for things like "Total Leads: 347"


/**
 * NOTES-SUMMARY-KPI'S
 * 
 * What this component does:
 *  - Displays a single metric in a card
 *  - Props (inputs): title, value, subtitle, color
 *  - Example: <KPICard title="Total Leads" value="347" color="blue" />

 * What are props?
 *  Props are like function parameters. You pass data into the component.
 */


import React from 'react';
import InfoTooltip from '../common/InfoTooltip';
import '../../styles/components.css';

function KPICard({ title, value, subtitle, color, tooltip }) {
  return (
    <div className="kpi-card">
      <div className="kpi-header">
        <h3 className="kpi-title">
          {title}
          {tooltip && <InfoTooltip text={tooltip} position="bottom" />}
        </h3>
      </div>
      
      <div className="kpi-body">
        <p className="kpi-value" style={{ color: color }}>
          {value}
        </p>
        
        {subtitle && (
          <p className="kpi-subtitle">{subtitle}</p>
        )}
      </div>
    </div>
  );
}

export default KPICard;